import script from "./ResultPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ResultPage.vue?vue&type=script&setup=true&lang=js"

import "./ResultPage.vue?vue&type=style&index=0&id=44d0ec7a&lang=scss&scoped=true"

import exportComponent from "/Users/zhangyi/WebstormProjects/aigc-poc-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44d0ec7a"]])

export default __exports__